module.exports = __webpack_public_path__ + "static/media/19ESCAP45.954c8eb7.jpg";